module.exports = __webpack_public_path__ + "staticcomp/img/top.8ca054a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/14/top.jpg
// module id = 72c/
// module chunks = 39